import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useMemo } from 'react';
import { useChartData } from '../context/ChartContext';
import { get2DXScale, get2DYScale } from './utilities/scale';
const lineStyle = css `
  stroke: green;
  stroke-width: 2;
  opacity: 0.5;
`;
function SignalDeltaLine({ delta, axis, show }) {
    const { margin, width, height, xDomain, yDomain } = useChartData();
    const scaleX = get2DXScale({ margin, width, xDomain });
    const scaleY = get2DYScale({ margin, height, yDomain });
    const line = useMemo(() => {
        return show ? (axis === 'X' ? (_jsx("line", { css: lineStyle, x1: scaleX(delta), x2: scaleX(delta), y1: scaleY(yDomain[0]), y2: scaleY(yDomain[1]) }, `signalLine_${delta}_X`)) : axis === 'Y' ? (_jsx("line", { css: lineStyle, x1: scaleX(xDomain[0]), x2: scaleX(xDomain[1]), y1: scaleY(delta), y2: scaleY(delta) }, `signalLine_${delta}_Y`)) : null) : null;
    }, [axis, delta, scaleX, scaleY, show, xDomain, yDomain]);
    return _jsx("g", { children: line });
}
export default SignalDeltaLine;
